import type { UseCase } from '@/core/shared'
import type { UserRepository } from '@/core/user'

export const removeUser: UseCase<UserRepository, 'removeUser'> = repository => {
  return async (removeUser) => {
    await repository.removeUser(removeUser)
  }
}
